import { t } from "i18next";
import { useState, useEffect, useContext } from "react";
import { Container, Col, Row, Spinner } from "react-bootstrap";
import Axios from "../axios";
import AuthContext from "../context/AuthContext";
import { toast } from "react-hot-toast";
import { handleLogin } from "../components/MyNav/LoginButton";
import party from "party-js";
import AppInitializer from "../utils/Initializer/AppInitializer";
import { DateTime } from "luxon";
const Oauth = () => {
    const [oauthSuccess, setOauthSuccess] = useState(false);
    const [isAppInitializerSuccess, setIsAppInitializerSuccess] =
        useState(false);
    const [oauthLoading, setOauthLoading] = useState(true);
    const [count, setCount] = useState(3);
    const { login, loading, setLoading } = useContext(AuthContext);
    const handleCount = () => {
        const intervalID = setInterval(() => {
            setCount((count) => count - 1);
        }, 1000);
        setTimeout(() => {
            clearInterval(intervalID);
            window.location.replace("/");
        }, 2999);
        if (
            DateTime.now().year === 2026 &&
            DateTime.now().month === 12 &&
            [21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31].includes(
                DateTime.now().day,
            )
        ) {
            const emojis = [
                "apple",
                "balloon",

                "tada",
                "rose",
                "heart",
                "hearts",
                "bouquet",
                "butterfly",
                "cherry_blossom",
                "christmas_tree",
                "confetti_ball",
                "gift_heart",
                "gift",
                "hibiscus",
                "yellow_heart",
                "kissing_heart",
                "pink_heart",
                "orange_heart",
                "purple_heart",
                "sparkling_heart",
                "rainbow",
                "snowflake",
                "snowman",
                "strawberry",
                "flag-ca",
            ];
            for (const emoji of emojis) {
                party.resolvableShapes[emoji] =
                    `<img src=${require(`./../assets/img/${emoji}.png`)} />`;
            }
            party.confetti(document.getElementById("confetti"), {
                count: party.variation.range(160, 200),
                size: party.variation.range(0.16, 0.18),
                shapes: emojis,
            });
        } else {
            party.confetti(document.getElementById("confetti"), {
                count: party.variation.range(50, 100),
                size: party.variation.range(0.6, 1.4),
                shapes: ["star", "roundedSquare", "rectangle", "circle"],
            });
        }
    };
    const getUserToken = async () => {
        setOauthLoading(true);
        setLoading(true);
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const response_1 = await Axios.post(
                `${process.env.REACT_APP_API_BASE_URL}authorization/token`,
                { code: urlParams.get("code") },
            );
            const response_2 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}employee-profile/`,
                {
                    headers: {
                        Authorization: `JWT ${response_1.data["omc_token"]}`,
                    },
                },
            );
            const response_3 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}employee-profile-picture/`,
                {
                    headers: {
                        Authorization: `JWT ${response_1.data["omc_token"]}`,
                        "content-type": "image/jpeg",
                    },
                    responseType: "arraybuffer",
                },
            );
            const base64picture = btoa(
                new Uint8Array(response_3.data).reduce(
                    (data, byte) => data + String.fromCharCode(byte),
                    "",
                ),
            );
            const imageDataUrl = `data:image/jpeg;base64,${base64picture}`;
            login({
                token: response_1.data["omc_token"],
                employee_profile: response_2.data,
                employee_profile_picture: imageDataUrl,
            });
            setOauthSuccess(true);
            AppInitializer(setLoading, setIsAppInitializerSuccess, handleCount);
        } catch (err) {
            toast.error(err.message);
            setOauthSuccess(false);
        } finally {
            console.info(`\u2605 Oauth Fired`);
            setOauthLoading(false);
        }
    };
    useEffect(() => {
        getUserToken();
        document.title = t("common:authentication");
    }, []);
    return (
        <Container className="mt-10">
            <div id="confetti" className="mx-auto col-3"></div>
            {oauthSuccess && !oauthLoading && (
                <>
                    <Row className="row-cols-1 justify-content-center align-items-center">
                        {loading && (
                            <>
                                <Col xs="auto">
                                    <Spinner
                                        animation="border"
                                        variant="secondary"
                                    />
                                </Col>
                                <Col xs="auto" className="text-secondary">
                                    <h1>{t("common:initializing")}</h1>
                                </Col>
                            </>
                        )}
                        {isAppInitializerSuccess && !loading && (
                            <>
                                <Col className="mb-3 text-center">
                                    <h1>{t("pages:login_success")}</h1>
                                </Col>
                                <Col className="text-center">
                                    <h3>
                                        {t("pages:redirect_home")} {count}s ...
                                    </h3>
                                </Col>
                            </>
                        )}
                    </Row>
                    {!isAppInitializerSuccess && !loading && (
                        <>
                            <Row className="justify-content-center align-items-center">
                                <Col xs="auto">
                                    <h1>
                                        <i className="bi bi-exclamation-triangle-fill text-warning me-3"></i>
                                        {t("errors:err_initialization")}
                                    </h1>
                                </Col>
                            </Row>
                            <Row className="justify-content-center align-items-center mt-3">
                                <Col xs="auto">
                                    <h3 className="text-center">
                                        {t("suggestions:contactAdmin")}
                                    </h3>
                                </Col>
                            </Row>
                        </>
                    )}
                </>
            )}
            <Row className="justify-content-center align-items-center">
                {!oauthSuccess && !oauthLoading && (
                    <Col xs="auto">
                        <h1>
                            <i className="bi bi-exclamation-triangle-fill text-warning me-3"></i>
                            {t("pages:login_fail")}{" "}
                            <a
                                style={{ cursor: "pointer" }}
                                onClick={handleLogin}
                                className="link-offset-1-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover"
                            >
                                {t("common:login")}
                            </a>{" "}
                            {t("pages:again")}
                        </h1>
                    </Col>
                )}
                {oauthLoading && (
                    <>
                        <Col xs="auto">
                            <Spinner animation="border" variant="secondary" />
                        </Col>
                        <Col xs="auto" className="text-secondary">
                            <h1>{t("common:loading")}</h1>
                        </Col>
                    </>
                )}
            </Row>
        </Container>
    );
};
export default Oauth;
